import React, { Component } from 'react'
import DocumentTitle from 'react-document-title'
import { observer } from 'mobx-react'
import moment from 'moment'

import Header from '@components/Details/Header'
import Button from '@components/Button'
import InfoBox from '@components/InfoBox'
import FormError from '@components/FormError'
import { notificationApi } from '@atheneum/api'
import Radio from '@components/Radio'

class AnnounceDeploymentPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      from: '12:30',
      duration: 30,
      error: null,
      reason: 'the latest version of the Platform'
    }
  }

  handleFromChange = e => {
    this.setState({ from: e.target.value })
  }

  handleDurationChange = e => {
    this.setState({ duration: e.target.value })
  }

  sendAnnouncement = () => {
    const [hours, minutes] = this.state.from.split(':')
    if (!this.state.from) {
      this.setState({
        error: 'All the fields have to be filled to announce the deployment'
      })
      return
    }
    const data = {
      from: moment()
        .set({ hours, minutes })
        .toISOString(),
      duration: this.state.duration,
      reason: this.state.reason
    }
    notificationApi.announceDeployment(data).catch(() => {
      this.setState({
        error: 'All the fields have to be filled to announce the deployment'
      })
    })
  }

  sendLastReminder = () => {
    notificationApi.sendLastReminderToEmployees()
  }

  render () {
    const options = [
      'the latest version of the Platform',
      'important fixes on the Platform'
    ]
    return (
      <DocumentTitle title='Announce deployment | Atheneum Partners'>
        <div>
          <div className='expert-search'>
            <div className='project-wrapper'>
              <Header>
                <div className='info info--noLeft'>
                  <div className='name-status-wrapper'>
                    <h1>Announce deployment</h1>
                  </div>
                </div>
              </Header>
              <div className='booking-stop-wrapper' style={{ width: '450px' }}>
                <InfoBox>
                  Choose start time and duration for today's deployment. Use
                  last reminder button to notify employees that deployment will
                  be starting in one minute.
                </InfoBox>
                <div className='expert-form__input-group m-t-lg'>
                  <label className='expert-form__label'>
                    From:<strong> *</strong>
                  </label>
                  <input
                    style={{ width: '240px' }}
                    value={this.state.from}
                    type='time'
                    onChange={this.handleFromChange}
                  />
                </div>
                <div className='expert-form__input-group'>
                  <label className='expert-form__label'>
                    Duration (min):<strong> *</strong>
                  </label>
                  <input
                    type='number'
                    style={{ width: '240px' }}
                    value={this.state.duration}
                    onChange={this.handleDurationChange}
                  />
                </div>
                <div className='expert-form__input-group'>
                  <label className='expert-form__label'>
                    Deployment reason:<strong> *</strong>
                  </label>
                  <div className='radio-group__container'>
                    {options.map(option => (
                      <div key={option} className='radio-group__item'>
                        <Radio
                          checked={this.state.reason === option}
                          onChange={() => {
                            this.setState({ reason: option })
                          }}
                        />
                        <span className='radio-group__item__label'>
                          {option}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className='expert-form__section'>
                  <FormError error={this.state.error} />
                  <Button primary onClick={this.sendAnnouncement}>
                    Announce
                  </Button>
                  <Button primary onClick={this.sendLastReminder}>
                    Last reminder
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default observer(AnnounceDeploymentPage)
